// Defining the area libary or timeline
import hero from "src/components/hero/hero";
import timelinenav from "src/components/timelinenav/timelinenav";
import { timelinenav_postrender } from "src/components/timelinenav/timelinenav";
import highlight from "src/components/highlight/highlight";
import { highlight_start } from "src/components/highlight/highlight";
import { articlesExtend, getDynamicContent, findsite } from "src/scripts/mixin";
import { postRenderFunctions } from "src/components/highlight/highlight_postrender";

export default () => {

    const contentcontainer = document.getElementById("site_content");

    const siteinfo = findsite(); 
    
    document.title = siteinfo.previewItem + " - Kongsberg historiefortelling";

    const setinnerHtml = (data) => {
        
        let r = ``;
        r = hero(data);
        
        r += timelinenav(siteinfo); 
        
        r += highlight();
        
        if(data.metaDynamicId['a55f452b-78ae-4ff4-a937-73efb539dc3e']){
            // console.log("metaDynamicId['a55f452b-78ae-4ff4-a937-73efb539dc3e']", data.metaDynamicId['a55f452b-78ae-4ff4-a937-73efb539dc3e'])
            document.head.children.Description.content = data.metaDynamicId['a55f452b-78ae-4ff4-a937-73efb539dc3e'];
        }
        
        // r += 
        contentcontainer.innerHTML = r;
        
        
        timelinenav_postrender();
        
        highlight_start(() => {
            postRenderFunctions();
        }); // first 
        
        
    }
    let senddata = {
        "categoryId": siteinfo.categoryId,
        "subscriptionId": config.clientId
    };

    fetch(window.apiUrl + "/api/PublicContentApi/getbycategoryidasstring", { //
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(senddata),
        })
        .then(response => response.json())
        .then(data => {

            // if (data.result) {

            data = data[0];
            articlesExtend(data);

            if (data.metaParsed.imageContentId) {
                fetch(window.apiUrl + "/api/PublicContentApi/find/" + data.metaParsed.imageContentId).then(response => response.json()).then(image => {
                    if (image) {
                        // data = articlesExtend(data);
                        // resolve(data);
                        
                        data.image = image;
                        
                        setinnerHtml(data);
                    }
                })

            }
            else {
                setinnerHtml(data)
            }
            // }

        });

}
